"use client";

import { Button } from "@/components/ui/button";
import Link from "next/link";
import { CalendarDays, UtensilsCrossed } from "lucide-react";

export function MobileStickyBar() {
  return (
    <div className="safe-area-bottom fixed right-0 bottom-0 left-0 z-40 flex gap-3 border-t border-[var(--roma-parchment-line)] bg-[var(--roma-ivory)]/90 p-4 backdrop-blur-lg md:hidden">
      <Button className="roma-cta flex-1 rounded-full shadow-lg" asChild>
        <Link href="/reservations">
          <CalendarDays className="mr-2 h-4 w-4" />
          Book Table
        </Link>
      </Button>
      <Button
        variant="outline"
        className="flex-1 rounded-full border-[var(--roma-parchment-line)] bg-[var(--roma-linen)]/55 text-[var(--foreground)] shadow-sm hover:bg-[var(--roma-linen)]"
        asChild
      >
        <Link href="/menu">
          <UtensilsCrossed className="mr-2 h-4 w-4" />
          View Menu
        </Link>
      </Button>
    </div>
  );
}
